module.exports = __webpack_public_path__ + "static/media/comp.e2c8712a.svg";